import { ReactNode } from "react";

interface IProps {
  title?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
}

export default function UiConfigCardItem({ title, children, footer }: IProps) {
  return (
    <div className="border px-8 py-4 rounded-xl mx-3 mt-3 shadow-[0_1px_2px_0px_rgba(16,24,40,0.05)]">
      {/* shadow-[0_1px_2px_0px_rgba(16, 24, 40, 0.05)] w-full bg-white  */}

      {/* {title && (
        <div className="text-[#101828] text-lg font-semibold">{title}</div>
        // font-extrabold text-[#004A8F] tracking-wide text-xl whitespace-normal break-all text-wrap w-full
      )} */}

      <div className="mt-6 grid grid-cols-2 gap-6">{children}</div>
      {/* <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6 w-full mb-2">{children}</div> */}

      {footer && (
        <div className="flex items-center justify-between mt-6 pt-4 border-t">
          {footer}
        </div>
      )}
    </div>
  );
}
